import { render, staticRenderFns } from "./SmartGateTurnstiles.vue?vue&type=template&id=6c41d64f&scoped=true"
import script from "./SmartGateTurnstiles.vue?vue&type=script&lang=js"
export * from "./SmartGateTurnstiles.vue?vue&type=script&lang=js"
import style0 from "./SmartGateTurnstiles.vue?vue&type=style&index=0&id=6c41d64f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c41d64f",
  null
  
)

export default component.exports